import React from 'react';
import {Image} from 'polyphony/components/generic';
import {MediaPicker} from 'polyphony/components/backend';
import {X, Pencil} from 'polyphony/icons';

const ImageFrontend = ({media, objectFit, lazy, enableLightbox, width, height}) => {
    const img = <Image lazy={lazy} media={media}
                       style={{objectFit,width,height,cursor: enableLightbox ? 'pointer' : undefined}} />;
    if (enableLightbox) {
        return <a className='polyphony-fancybox' href={media.url}>{img}</a>;
    }
    return img;
};

const ImageEditor = ({gutenberg:{setProp}, media, objectFit, lazy, enableLightbox, width, height}) => {
    const setter = k => v => setProp(k, v);
    const setObjectFit = setter('objectFit');
    const setWidth = setter('width');
    const setHeight = setter('height');
    const setMedia = setter('media');
    const onLightboxClick = e => setter('enableLightbox')(e.target.checked);
    const onLazyClick = e => setter('lazy')(e.target.checked);

    const { BlockControls, InspectorControls } = window.wp.editor;
    const { Toolbar, DropdownMenu, TextControl } = window.wp.components;

    const style = {
        editorContainer: {
            background: 'rgba(139,139,150,.1)'
        },
        inspectorControl: {
            display: 'flex',
            alignItems: 'flex-start',
            margin: -16,
            padding: 16
        }
    };

    if (media) {
        return (
            <>
                <InspectorControls>
                    <div style={style.inspectorControl}>
                        <input type="checkbox" id='lightbox' value='true' style={{marginTop: 1.5}} checked={enableLightbox} onClick={onLightboxClick} />
                        <label {...{for: 'lightbox'}}>Enable Lightbox?</label>
                    </div>
                    <div style={style.inspectorControl}>
                        <input type="checkbox" id='lightbox' value='true' style={{marginTop: 1.5}} checked={lazy} onClick={onLazyClick} />
                        <label htmlFor='lightbox'>Lazy load?</label>
                    </div>
                    <div style={style.inspectorControl}>
                        <TextControl label="Width" value={width} onChange={setWidth} />
                    </div>
                    <div style={style.inspectorControl}>
                        <TextControl label="Height" value={height} onChange={setHeight} />
                    </div>
                </InspectorControls>
                <BlockControls>
                    <Toolbar controls={[
                        {
                            title: 'Edit Selection',
                            icon: <Pencil />,
                            onClick: () => MediaPicker.openMediaPicker(media, setMedia)
                        },
                        {
                            title: "Clear Selection",
                            icon: <X />,
                            onClick: () => setMedia(null)
                        }
                    ]}>
                        <DropdownMenu icon="image-crop" label="Object Fit" controls={[
                            {isDisabled: objectFit === 'none' || !objectFit, title: 'None', onClick: () => setObjectFit('none')},
                            {isDisabled: objectFit === 'contain', title: 'Contain', onClick: () => setObjectFit('contain')},
                            {isDisabled: objectFit === 'cover', title: 'Cover', onClick: () => setObjectFit('cover')},
                            {isDisabled: objectFit === 'fill', title: 'Fill', onClick: () => setObjectFit('fill')},
                            {isDisabled: objectFit === 'scale-down', title: 'Scale Down', onClick: () => setObjectFit('scale-down')}
                        ]}/>
                    </Toolbar>
                </BlockControls>
                <Image style={{objectFit, height: '100%', width: '100%'}} media={media} />
            </>
        );
    }
    return (
        <div style={style.editorContainer}>
            <MediaPicker supportsFit={false} onMediaChange={setMedia} media={media} />
        </div>
    );
};

const ImageBlock = props => {
    if (props.gutenberg.isEditor) return <ImageEditor {...props} />;
    return <ImageFrontend {...props} />;
};

ImageBlock.category = 'common';
ImageBlock.keywords = ['image', 'polyphony'];
ImageBlock.icon = 'format-image';
ImageBlock.title = "Polyphony Image";
ImageBlock.slug = 'image';
ImageBlock.blockName = 'polyphony/image'; // Necessary???

polyphony.addBlock(ImageBlock);

